var _defs, _rect, _rect2, _rect3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActivitePaylaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.069,
    y1: -0.147,
    x2: 0.84,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5514",
    "data-name": "Rectangle 5514",
    width: 40,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5515",
    "data-name": "Rectangle 5515",
    width: 7.2,
    height: 12,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35528",
    "data-name": "Group 35528",
    transform: "translate(-21 -302)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35543",
    "data-name": "Group 35543",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513-2",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5523",
    "data-name": "Rectangle 5523",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35527",
    "data-name": "Group 35527",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35524",
    "data-name": "Group 35524",
    transform: "translate(39 318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35523",
    "data-name": "Group 35523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38655",
    "data-name": "Path 38655",
    d: "M17.418,32.477H4.476A3.809,3.809,0,0,1,.667,28.669V5.811A3.81,3.81,0,0,1,4.476,2H27.333a3.81,3.81,0,0,1,3.809,3.811V16.429",
    transform: "translate(1.239 3.714)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38656",
    "data-name": "Path 38656",
    d: "M14,20a6,6,0,1,0-6-6A6,6,0,0,0,14,20Z",
    transform: "translate(16.415 16.415)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_498",
    "data-name": "Line 498",
    y2: 7.62,
    transform: "translate(24.762 1.905)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_499",
    "data-name": "Line 499",
    y2: 7.62,
    transform: "translate(9.524 1.905)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38660",
    "data-name": "Path 38660",
    d: "M0,0H30.477",
    transform: "translate(1.905 16.143)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38657",
    "data-name": "Path 38657",
    d: "M10.667,9.661v2.866l1.906,1.9",
    transform: "translate(19.81 17.942)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35526",
    "data-name": "Group 35526",
    transform: "translate(53 337.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35525",
    "data-name": "Group 35525",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38658",
    "data-name": "Path 38658",
    d: "M6.486,3.867a1.8,1.8,0,0,0-1.62-1.2h-2.4a1.8,1.8,0,0,0,0,3.6h2.4a1.8,1.8,0,0,1,0,3.6h-2.4a1.8,1.8,0,0,1-1.62-1.2",
    transform: "translate(-0.067 -0.267)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38659",
    "data-name": "Path 38659",
    d: "M4,9.667v1.8M4,.667v0Z",
    transform: "translate(-0.4 -0.067)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActivitePaylaterIcon);
export default __webpack_public_path__ + "static/media/profile-activite-paylater-icon.f1fef97606fb5517465b848a95cf1525.svg";
export { ForwardRef as ReactComponent };